import React from 'react';
import './loader.css';
import teamlogo from "../../../assets/img/teamlogo.png"
import loader1 from "../../../assets/img/loader1.gif"

export default function Loader() {
	return (
		<div className='mainloader'>
			<img src={teamlogo} alt="Team Computers Logo" className='Loaderimage' />
			<img src={loader1} alt='loader'/>
		</div>
	);
}
